import api from './api';

const accessibilityService = {
  // Get latest accessibility audit
  getAuditOverview: async () => {
    const response = await api.get('/api/accessibility/audits/latest');
    return response.data;
  },

  // Get alt text coverage report - not implemented yet
  getAltTextCoverage: async () => {
    const response = await api.get('/api/accessibility/alt-text-coverage');
    return response.data;
  },

  // Get transcript status report - not implemented yet
  getTranscriptStatus: async () => {
    const response = await api.get('/api/accessibility/transcript-status');
    return response.data;
  },

  // Get WCAG compliance checklist - not implemented yet
  getWcagChecklist: async () => {
    const response = await api.get('/api/accessibility/wcag-checklist');
    return response.data;
  },

  // Get accessibility issues
  getIssues: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.type) params.append('type', filters.type);
    if (filters.status) params.append('status', filters.status);
    if (filters.category) params.append('category', filters.category);

    const response = await api.get(`/api/accessibility/issues?${params.toString()}`);
    return response.data;
  },

  // Update issue status - uses PATCH
  updateIssueStatus: async (id, status) => {
    const response = await api.patch(`/api/accessibility/issues/${id}/status`, { status });
    return response.data;
  },

  // Create new accessibility audit
  runAudit: async () => {
    const response = await api.post('/api/accessibility/audits');
    return response.data;
  },

  // Get audit history (paginated list)
  getAuditHistory: async (params = {}) => {
    const response = await api.get('/api/accessibility/audits', { params });
    return response.data;
  },

  // Get single audit by ID
  getAudit: async (id) => {
    const response = await api.get(`/api/accessibility/audits/${id}`);
    return response.data;
  },

  // Get issues for specific audit
  getAuditIssues: async (auditId) => {
    const response = await api.get(`/api/accessibility/audits/${auditId}/issues`);
    return response.data;
  },

  // Get accessibility statistics
  getStatistics: async () => {
    const response = await api.get('/api/accessibility/statistics');
    return response.data;
  },

  // Create issue manually
  createIssue: async (data) => {
    const response = await api.post('/api/accessibility/issues', data);
    return response.data;
  },
};

export default accessibilityService;
